import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import CalendarPage from "./pages/CalendarPage";
import Training from "./pages/Training";
import Rounds from "./pages/Rounds";
import Progress from "./pages/Progress";
import Profile from "./pages/Profile";

const wrap = (el) => (
  <ProtectedRoute>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/onboarding" element={<ProtectedRoute><Onboarding /></ProtectedRoute>} />
            <Route path="/" element={wrap(<Dashboard />)} />
            <Route path="/calendar" element={wrap(<CalendarPage />)} />
            <Route path="/training/:date" element={wrap(<Training />)} />
            <Route path="/rounds" element={wrap(<Rounds />)} />
            <Route path="/progress" element={wrap(<Progress />)} />
            <Route path="/profile" element={wrap(<Profile />)} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
